import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'


function SearchBox({ basePath = '/shop' }) {
  const [keyword, setKeyword] = useState('')

  let history = useHistory()

  const submitHandler = (e) => {
    e.preventDefault()
    if(keyword){
      history.push(`${basePath}/?keyword=${keyword}&page=1`)
    }else{
      history.push(history.location.pathname)
    }
  }
  

  return (
  <div>
    <Form onSubmit={submitHandler} className='inline d-flex mx-3 my-3'>
      <Form.Control
        type='text'
        name='q'
        onChange ={(e) => setKeyword(e.target.value)}
        className='mr-sm-2 ml-sm-5'
      ></Form.Control>
      <Button
      type='submit'
      variant='outline-success'
      className='p-2'>
        Ricerca
      </Button>
    </Form>
  </div>
  )
}

export default SearchBox